import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

// This legacy route shouldn't be on the root; it is to create an entity; redirect to a reasonable route.
export const Route = createFileRoute('/_legacy/create')({
  validateSearch: z.object({
    entityType: z.number(),
    parentEntity: z.number().optional(),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/entity/new', search, replace: true })
  },
})
